import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { AlertCircle, Home, ArrowLeft } from 'lucide-react';

export function AgreementNotFound() {
  const { agreement_id } = useParams<{ agreement_id: string }>();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
            <AlertCircle className="h-8 w-8 text-red-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Agreement Not Found
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            The agreement you're looking for doesn't exist or may have been removed.
          </p>
          {agreement_id && (
            <div className="bg-gray-100 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-700">
                <span className="font-medium">Agreement ID:</span> {agreement_id}
              </p>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="text-sm text-gray-600">
            <p className="mb-4">This could happen if:</p>
            <ul className="text-left space-y-2 max-w-xs mx-auto">
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                The agreement ID is incorrect or invalid
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                The agreement has been deleted
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                You don't have permission to access this agreement
              </li>
            </ul>
          </div>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              If you believe this is an error, please contact support with the agreement ID above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}